import { createFileRoute } from "@tanstack/react-router"

import { issueTypeDetailsViewStaticData } from "../../../../../../../../views/IssueTypeSettingsDetailView/constants"
import { IssueTypeSettingsDetailView } from "../../../../../../../../views/IssueTypeSettingsDetailView/IssueTypeSettingsDetailView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/")({
	component: IssueTypeSettingsDetailView,
	staticData: issueTypeDetailsViewStaticData,
})
